import { cn } from '@/lib/utils';

interface DashPanelProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'none' | 'sm' | 'md';
}

const paddingMap = {
  none: '',
  sm: 'p-4',
  md: 'p-5',
};

/** Cartão padrão do dashboard — radius 12px e sombra suave (design system BI). */
export function DashPanel({
  children,
  className,
  padding = 'md',
}: DashPanelProps) {
  return (
    <div
      className={cn(
        'rounded-xl border border-border bg-card text-card-foreground shadow-[0_1px_2px_rgba(0,0,0,0.05)]',
        paddingMap[padding],
        className
      )}
    >
      {children}
    </div>
  );
}
